var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCompany = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 878.000000 980.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,980.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4910 8970 c-1114 -456 -2123 -869 -2242 -917 l-218 -88 0 -615 0 -615 205 205 205 205 0 306 0 307 48 20 c53 23 3801 1602 3819 1609 6 2 241 -271 522 -608 l511 -613 0 -3778 0 -3778 510 0 510 0 0 205 0 205 -305 0 -305 0 0 3572 0 3571 -612 818 c-337 450 -615 818 -618 818 -3 0 -916 -373 -2030 -829z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6740 4692 l0 -4082 305 0 305 0 0 3723 0 3723 -291 344 c-160 190 -297 352 -305 360 -12 12 -14 -569 -14 -4068z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2570 6484 c-822 -360 -1552 -679 -1622 -710 l-128 -56 0 -2349 0 -2349 -410 0 -410 0 0 -205 0 -205 612 2 613 3 3 2450 3 2450 1417 607 c779 334 1422 608 1428 610 6 2 284 -193 616 -432 l605 -435 7 -44 c3 -24 6 -1206 6 -2627 l0 -2584 510 0 510 0 0 205 0 205 -305 0 -305 0 0 2450 0 2450 -813 610 c-448 335 -820 610 -828 609 -8 0 -687 -295 -1509 -655z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4082 3368 l3 -2753 305 0 305 0 2 2550 3 2550 -301 200 c-166 110 -305 202 -310 203 -5 2 -8 -1134 -7 -2750z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2543 5193 l-713 -316 0 -196 c0 -108 3 -286 7 -397 l6 -201 691 297 c380 163 701 302 714 309 l22 12 0 404 c0 223 -3 405 -7 404 -5 0 -329 -143 -720 -316z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2540 3446 l-705 -223 2 -383 c2 -211 4 -384 5 -386 2 -1 323 89 713 200 l710 203 3 407 c2 322 0 406 -10 406 -7 -1 -330 -101 -718 -224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2548 1837 l-708 -202 0 -307 0 -308 715 0 715 0 0 510 c0 281 -3 510 -7 509 -5 0 -326 -91 -715 -202z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 205 l0 -205 4390 0 4390 0 0 205 0 205 -4390 0 -4390 0 0 -205z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompany, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/company.dcbb1722.svg";
export { ForwardRef as ReactComponent };